
import React, {useEffect} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {Link} from 'react-router-dom'
import LIFromFiltrosProducto from './Components/LIFromFiltrosProducto'
import './styles/lista-producto.css'
import TableListProducto from './Components/TableListProducto'
import ModalsControls from '../../GestionUsuarios/CrearUsuario/modals/ModalsControls'
import ModalsControlsProduct from '../modals/ModalControlsProduct'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionsGPlistarProductos} from '../../../actions/action-creators'
import {gu_lu_Clear} from '../../../actions/gestion-usuario/lista-usuario/listaUsuario.actions'
import { gp_lp_Clear } from '../../../actions/gestion-producto/lista-producto/listaProductos.actions'

const ListaProducto = () => {
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGPlistarProductos, dispatch)
  useEffect(() => {
    window.scroll(0, 0)
    actions.gp_lp_GetProductos()
    return () => {
      dispatch(gp_lp_Clear)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BasicLayout>
      <ModalsControlsProduct />
      <div className='header'>
        <Link to='/gestion-productos' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Lista de Productos</h3>
      </div>
      <div className='separador'></div>
      <LIFromFiltrosProducto />
      <TableListProducto />
    </BasicLayout>
  )
}

export default ListaProducto
